import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setBettingDisabledStatus } from '@mobi/betslip/Store/Workflow'
import { Banner } from '@mobi/component-library/Feedback/Banner'
import { Constants } from '@mobi/settings'
import { useTakeABreak } from '@core/Areas/Account/Pages/TakeABreak/hooks/useTakeABreak'

export const TakeABreakStatus = () => {
  const dispatch = useDispatch()

  const { data: takeABreakStatus } = useTakeABreak()

  useEffect(() => {
    dispatch(setBettingDisabledStatus(takeABreakStatus?.inProgress ?? false))
  }, [dispatch, takeABreakStatus])

  if (!takeABreakStatus?.inProgress) return null

  return (
    <Banner
      text={`Betting is currently disabled for this account. For more information, call ${Constants.GamblingHelpPhoneNumber}`}
      type='error'
    />
  )
}
